var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_382",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29234",
    "data-name": "Group 29234",
    transform: "translate(360 10673)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -360, -10673)",
    filter: "url(#Ellipse_382)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_382-2",
    "data-name": "Ellipse 382",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50364",
    "data-name": "Path 50364",
    d: "M429.474,174.437V173.36a.387.387,0,0,0-.265-.367l-3.482-1.16a.387.387,0,0,0-.509.367v2.238Z",
    transform: "translate(-734.89 -10818.193)",
    fill: "#ff7d5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50365",
    "data-name": "Path 50365",
    d: "M36.672,301.518H26.743a.709.709,0,0,1-.709-.709V299.39H36.672Z",
    transform: "translate(-368.328 -10935.345)",
    fill: "#8d8a94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50366",
    "data-name": "Path 50366",
    d: "M27.157,284.162H9.387a.709.709,0,0,1-.709-.709v-1.418h23.4l-3.656,1.828a2.838,2.838,0,0,1-1.269.3Z",
    transform: "translate(-352.39 -10919.407)",
    fill: "#a7a5ac"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_486",
    "data-name": "Ellipse 486",
    cx: 2.128,
    cy: 2.128,
    r: 2.128,
    transform: "translate(-335.202 -10636.664)",
    fill: "#504b5a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_487",
    "data-name": "Ellipse 487",
    cx: 1.064,
    cy: 1.064,
    r: 1.064,
    transform: "translate(-334.138 -10635.6)",
    fill: "#dcdbde"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488",
    "data-name": "Ellipse 488",
    cx: 2.128,
    cy: 2.128,
    r: 2.128,
    transform: "translate(-339.457 -10636.664)",
    fill: "#504b5a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_489",
    "data-name": "Ellipse 489",
    cx: 1.064,
    cy: 1.064,
    r: 1.064,
    transform: "translate(-338.393 -10635.6)",
    fill: "#dcdbde"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50367",
    "data-name": "Path 50367",
    d: "M321.085,290.712h15.6v2.837h-15.6Z",
    transform: "translate(-639.266 -10927.376)",
    fill: "#b9b7bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_490",
    "data-name": "Ellipse 490",
    cx: 2.128,
    cy: 2.128,
    r: 2.128,
    transform: "translate(-316.053 -10636.664)",
    fill: "#504b5a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_491",
    "data-name": "Ellipse 491",
    cx: 1.064,
    cy: 1.064,
    r: 1.064,
    transform: "translate(-314.99 -10635.6)",
    fill: "#dcdbde"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_492",
    "data-name": "Ellipse 492",
    cx: 2.128,
    cy: 2.128,
    r: 2.128,
    transform: "translate(-320.309 -10636.664)",
    fill: "#504b5a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_493",
    "data-name": "Ellipse 493",
    cx: 1.064,
    cy: 1.064,
    r: 1.064,
    transform: "translate(-319.245 -10635.6)",
    fill: "#dcdbde"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50368",
    "data-name": "Path 50368",
    d: "M432.312,204.474h-3.546v-1.418H425.22v-7.8h5.757a.709.709,0,0,1,.7.621l.495,3.957a17.724,17.724,0,0,1,.137,2.2Z",
    transform: "translate(-734.891 -10839.719)",
    fill: "#ff9164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50369",
    "data-name": "Path 50369",
    d: "M468.61,290.712h3.546v1.418H468.61Z",
    transform: "translate(-774.735 -10927.376)",
    fill: "#ff7d5a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_494",
    "data-name": "Ellipse 494",
    cx: 2.128,
    cy: 2.128,
    r: 2.128,
    transform: "translate(-308.252 -10636.664)",
    fill: "#504b5a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_495",
    "data-name": "Ellipse 495",
    cx: 1.064,
    cy: 1.064,
    r: 1.064,
    transform: "translate(-307.188 -10635.6)",
    fill: "#dcdbde"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50370",
    "data-name": "Path 50370",
    d: "M444.7,212.61h-1.773a.355.355,0,0,0-.355.355v2.056a.532.532,0,0,0,.416.519l1.711.38Z",
    transform: "translate(-750.828 -10855.656)",
    fill: "#ff7d5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50371",
    "data-name": "Path 50371",
    d: "M448.113,215.77l-.4-3.16h-4.787a.355.355,0,0,0-.355.355v2.056a.532.532,0,0,0,.417.519L448.2,216.7C448.177,216.387,448.151,216.078,448.113,215.77Z",
    transform: "translate(-750.828 -10855.656)",
    fill: "#ff7d5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50372",
    "data-name": "Path 50372",
    d: "M468.61,215.92l3.5.777c-.022-.309-.048-.619-.087-.927l-.4-3.16H468.61Z",
    transform: "translate(-774.735 -10855.656)",
    fill: "#625d6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50373",
    "data-name": "Path 50373",
    d: "M.709,169.22H33.332a.709.709,0,0,1,.709.709v8.511a.709.709,0,0,1-.709.709H.709A.709.709,0,0,1,0,178.44v-8.511a.709.709,0,0,1,.709-.709Z",
    transform: "translate(-344.421 -10815.813)",
    fill: "#ffb47d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50374",
    "data-name": "Path 50374",
    d: "M47.851,257.417H18.064a.709.709,0,1,1,0-1.418H47.851a.709.709,0,1,1,0,1.418Z",
    transform: "translate(-360.358 -10895.5)",
    fill: "#ff9164"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.d21d8b81e5c1958a54d37a0e40a7c409.svg";
export { ForwardRef as ReactComponent };